import deepmerge from 'deepmerge';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaExpandMoreIcon } from '../../icons';

const useStyles = makeStyles({ name: 'Link' })((theme) => deepmerge({
	root: {
		textDecoration: 'none',
		color: theme.palette.text.primary,
		cursor: 'pointer',
		fontSize: '12px',
		lineHeight: '20px',
		fontWeight: 'bold',
		letterSpacing: 0.75,
		textTransform: 'none',
		display: 'flex',
		alignItems: 'center',
		'&:active': {
			color: theme.palette.text.primary
		},
		'&:not(.btn)': {
			color: theme.palette.text.primary,
			'&:hover': {
				color: theme.palette.text.primary,
				textDecoration: 'none'
			}
		}
	},
	icon: {
		fontSize: 20,
		transform: 'rotate(-90deg)',
		color: theme.palette.skodaLinkIcon
	}
}, theme.Skoda?.overrides?.SkodaLink ?? {}));

export type SkodaLinkProps = React.HTMLProps<HTMLAnchorElement> & {
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
	hideIcon?: boolean;
};

export const SkodaLink: React.FC<SkodaLinkProps> = (props) => {
	const { classes, children, className, hideIcon, ...other } = props;
	const { classes: styles, cx } = useStyles(undefined, { props: { classes } });

	return (
		<a className={cx(styles.root, className)} {...other}>
			{children}
			{!hideIcon && <SkodaExpandMoreIcon className={styles.icon} />}
		</a>
	);
};
